import { initialState } from "./state"

export default {
  setStateCountry: (state, payload) => (state.stateCountry = payload),
  setPOS: (state, payload) => (state.pos = payload),
  setPosCnpj: (state, payload) => (state.posCnpj = payload),
  setSeller: (state, payload) => (state.seller = payload),
  updateCaptation: (state, payload) => (state.captation = payload),
  updateCaptationName: (state, payload) => (state.captationName = payload),
  updateWallet: (state, payload) => (state.wallet = payload),
  resetPOS: state => {
    const init_state = initialState()
    Object.keys(state).forEach(key => {
      state[key] = init_state[key]
    })
  }
}
